import React from 'react';
import { RightControllerButton, ArrowIcon, XIcon } from '../search-dropdown.style';
import { GetToggleButtonPropsOptions } from 'downshift';

interface IToggleDropdownArrow {
    getToggleButtonProps: (options?: GetToggleButtonPropsOptions | undefined) => any;
    isOpen: boolean;
}

export const ToggleDropdownArrow = ({ getToggleButtonProps, isOpen }: IToggleDropdownArrow) => {
    return (
        /* 
            The tabIndex and style are overridden because it takes two tabs for 
            a user to go from one control to another if the button is allowed to
            be tabbable. 
        */
        <RightControllerButton
            {...getToggleButtonProps()}
            style={{ outline: 'none' }}
            tabIndex="-1"
        >
            <ArrowIcon isOpen={isOpen} />
        </RightControllerButton>
    );
};

interface ICrossButton {
    ariaLabel: string;
    onClickHandler: () => void;
}

export const CrossButton = ({ ariaLabel, onClickHandler }: ICrossButton) => {
    return (
        <RightControllerButton onClick={onClickHandler} aria-label={ariaLabel}>
            <XIcon />
        </RightControllerButton>
    );
};
